<script setup>
import { ref } from 'vue'
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconElipsisVertical from '@/components/icon/IconElipsisVertical.vue'
import IconPlusSmall from '@/components/icon/IconPlusSmall.vue'
import IconChevronDown from '@/components/icon/IconChevronDown.vue'
import { DOCK_ADD_BUTTON } from './mediaflowMeta'

/**
 * Dock menus: a kebab (row actions) or "+ Add ▾" (add with templates). Teleported
 * so dock bodies can scroll without clipping it, and closed after any item is
 * picked (DropDownMenu only closes on outside clicks).
 */
const props = defineProps({
	kind: { type: String, default: 'kebab', validator: (v) => ['kebab', 'add'].includes(v) },
	ariaLabel: { type: String, required: true },
	disabled: { type: Boolean, default: false },
	listClasses: { type: String, default: 'min-w-[190px]' },
	position: { type: String, default: 'right' },
})

const menu = ref(null)
const close = () => menu.value?.hide?.()
defineExpose({ close })
</script>

<template>
	<DropDownMenu
		ref="menu"
		:type="kind === 'add' ? 'custom' : 'secondary'"
		size="sm"
		:is-icon="kind === 'kebab'"
		:position="position"
		use-teleport
		max-height="none"
		:disabled="disabled"
		:aria-label="ariaLabel"
		:list-classes="listClasses"
		:custom-classes="kind === 'add' ? `${DOCK_ADD_BUTTON}${disabled ? ' opacity-50 pointer-events-none' : ''}` : undefined"
	>
		<template #toggle-button>
			<template v-if="kind === 'add'">
				<icon-base width="11" height="11" :width-view-box="14" :height-view-box="14"><icon-plus-small /></icon-base>
				<span class="mf-dock-add-label">Add</span>
				<icon-base width="9" height="9" fill="none" class="mf-dock-add-label text-surface-7"><icon-chevron-down /></icon-base>
			</template>
			<icon-base v-else><icon-elipsis-vertical /></icon-base>
		</template>
		<template #menu-items>
			<div class="contents" @click="close">
				<slot />
			</div>
		</template>
	</DropDownMenu>
</template>
